"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowService = exports.windowService = void 0;
var privateWindow;
var setWindow = function (window) {
    privateWindow = window;
};
var getWindow = function () {
    var globalWindow = typeof window === "undefined" ? {} : window;
    var windowObject = privateWindow || globalWindow;
    setWindow(windowObject);
    return privateWindow;
};
var detectNavigator = function () {
    var window = getWindow();
    return window ? window.navigator : null;
};
exports.windowService = {
    detectNavigator: detectNavigator,
    getWindow: getWindow,
    setWindow: setWindow,
};
var WindowService = /** @class */ (function () {
    function WindowService() {
        return exports.windowService;
    }
    return WindowService;
}());
exports.WindowService = WindowService;
